const unibag = {
  FORMS: [
    {
      type: 'unibag-cotizar-form',
      name: 'UNIBAGCotizarForm',
      message: {
        open: 'Formulario cotización',
        send: 'Envío Formulario De Cotización'
      }
    }
  ],
  CSS: {
    id: '5fabec0a0f3d4477c5199a01',
    name: 'unibag',
    avatar: {
      name: 'Martina',
      header: 'https://chatbotqa.gatblac.com/static/avatar/unibag/marca_unibag.png',
      new: 'https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/6KoTvsGp9FAZ1655319179420.gif',
      open: 'https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/aT3DzbPR7Pk21655319167790.png',
      close: 'https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/AobAmNluYHVC1655319152567.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#02a9a7',
        borderColor: '#02a9a7'
      }
    }
  }
}

export default unibag
